import { useState } from "react";
import {gridMobile} from '../data/grid' ;

const Gridmobile = () => {
    // eslint-disable-next-line
    const [cards, setCards] = useState(gridMobile);

    return (
        <>
            <section className="grid grid-cols-2">
                {cards.map(({ id, image }) => (
                    <article id={id}>
                        <img src={image} alt="" />
                    </article>
                ))}
            </section>
        </>
    )
}

export default Gridmobile
